export default "__VITE_ASSET__Cs4QI0PK__"